import { Control, FieldPath, FieldValues } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import PrivacyToggle from './PrivacyToggle';

interface PreferenceToggleFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  description: string;
}

// A single labelled on/off row backed by a react-hook-form boolean field.
// Shared by the profile modal's Privacy and Notification sections.
function PreferenceToggleField<T extends FieldValues>({
  control,
  name,
  label,
  description,
}: PreferenceToggleFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">{label}</FormLabel>
            <div className="text-sm text-muted-foreground">{description}</div>
          </div>
          <FormControl>
            <PrivacyToggle
              value={Boolean(field.value)}
              onChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}

export default PreferenceToggleField;
